import React from 'react';
export const BoatTypesSection = () => {
  const boatTypes = [{
    id: 1,
    name: 'Sloepen'
  }, {
    id: 2,
    name: 'Zeilboten'
  }, {
    id: 3,
    name: 'Jachten'
  }, {
    id: 4,
    name: 'Tenders'
  }, {
    id: 5,
    name: 'Consoleboten'
  }, {
    id: 6,
    name: 'Speedboten / sportboten'
  }];
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-24">
      <div className="container mx-auto px-4" data-id="element-25">
        <h2 className="text-2xl md:text-3xl font-light text-center mb-12 text-gray-800" data-id="element-26">
          Wij stofferen o.a.
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-10 max-w-4xl mx-auto" data-id="element-27">
          {boatTypes.map(boat => <div key={boat.id} className="group relative" data-id="element-28">
              <div className="p-4 md:p-6 bg-gray-50 hover:bg-gray-100 rounded-md transition-colors duration-300 h-full flex items-center justify-center" data-id="element-29">
                <h3 className="text-center text-gray-800 text-lg md:text-xl font-normal" data-id="element-30">
                  {boat.name}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};